import { useDroppable } from "@dnd-kit/core";
import { Plus } from "lucide-react";
import { BookingChip } from "./BookingChip";

export const UnitCard = ({ group, unit, bookings, colorOf, isLate, onStatus, onWalkIn, onNoteSaved }) => {
  const { setNodeRef, isOver } = useDroppable({ id: `${group.id}::${unit.name}`, data: { group, unit } });
  const slug = unit.name.toLowerCase().replace(/\s+/g, "-");
  return (
    <div ref={setNodeRef} data-testid={`cal-unit-${slug}`}
      className={`rounded-lg border-2 p-2.5 min-h-[120px] flex flex-col gap-2 transition-colors ${
        isOver ? "border-[#b09873] bg-amber-50" : bookings.length ? "border-stone-200 bg-stone-50" : "border-dashed border-stone-200 bg-white"}`}>
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-stone-600">{unit.name.replace(group.name, "").trim() || unit.name}</span>
        <button onClick={() => onWalkIn(group, unit)} data-testid={`cal-walkin-${slug}`} aria-label={`Walk-in at ${unit.name}`}
          className="text-stone-400 hover:text-[#15262d] hover:bg-stone-100 rounded p-0.5 transition-colors">
          <Plus size={15} />
        </button>
      </div>
      {bookings.map((b) => (
        <BookingChip key={b.id} booking={b} color={colorOf(b.status)} late={isLate(b)} onStatus={onStatus} onNoteSaved={onNoteSaved} />
      ))}
      {!bookings.length && <span className="text-[11px] text-stone-400 m-auto">Free</span>}
    </div>
  );
};
